import { call, takeEvery, put } from "redux-saga/effects"
import { createActions } from "reduxsauce"
import { put as apiPut } from "api"
import { Creators as notificationCreators } from "modules/notifications/model"

export const { Types, Creators } = createActions({
  update: ["resource", "url", "payload", "options"],
  updateSuccess: ["resource", "id", "result", "payload", "options"],
  updateError: ["resource", "id", "error", "payload"],
}, {
  prefix: "ompnt/modules/updater/",
})

// By default, non-graphql id is the url
function* updateSaga({ resource, url, payload, options }) {
  try {
    const result = yield call(apiPut, url, payload)

    // Do not call update success on 204s
    if (result) {
      yield put(Creators.updateSuccess(resource, url, result, payload, options))
    }

    if (options && options.onSuccess) {
      yield put(notificationCreators.add("success", null, options.onSuccess))
    }
  } catch (error) {
    yield put(Creators.updateError(resource, url, error, payload))
    if (options && options.onError) {
      yield put(notificationCreators.add("error", null, options.onError))
    }
  }
}

export function* saga() {
  yield takeEvery(Types.UPDATE, updateSaga)
}
